import React, { ChangeEvent } from "react"
import { AppLinkMui } from "@ecom/ui/components/AppLink"
import Checkbox from "@material-ui/core/Checkbox"
import FormHelperText from "@material-ui/core/FormHelperText"
import { FormikTouched } from "formik"
import { WrapperDataLayer } from "./WrapperDataLayer"

import { CheckIcon } from "../icons/CheckIcon"
import { EmptyIcon } from "../icons/EmptyIcon"

import * as styles from "./fields.module.scss"

type Props = {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  value: boolean
  name: string
  id: string
  error?: string
  touched?: FormikTouched<{}>
}

export const AcceptmentField = ({ value, error, name, touched, ...props }: Props) => (
  <WrapperDataLayer touched={touched} error={error} name={name}>
    <div className={styles.acceptmentWrapper}>
      <div className={styles.acceptment}>
        <div>
          <Checkbox
            color="primary"
            checkedIcon={<CheckIcon />}
            icon={<EmptyIcon />}
            checked={value}
            className={styles.icon}
            {...props}
          />
        </div>
        <div>
          <FormHelperText>
            <span className={styles.acceptmentContent}>
              Выражаю{" "}
              <AppLinkMui
                className={styles.acceptmentLink}
                href="https://app.scb.ru/policy/"
                target="_blank"
                rel="noopener noreferrer"
                underline="always"
              >
                согласие
              </AppLinkMui>{" "}
              на&nbsp;обработку персональных данных и&nbsp;подтверждаю,&nbsp;что&nbsp; ознакомлен с
              <AppLinkMui
                className={styles.acceptmentLink}
                href="https://scb.ru/about/pages/policy-personal-data"
                target="_blank"
                rel="noopener noreferrer"
                underline="always"
              >
                {" "}
                Политикой
              </AppLinkMui>{" "}
              обработки персональных данных
            </span>
          </FormHelperText>
        </div>
      </div>
      <FormHelperText error classes={{ root: styles.acceptmentError }}>
        {error}
      </FormHelperText>
    </div>
  </WrapperDataLayer>
)
